import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { ApiRouting } from "@globals/classes/ApiRouting";
import { WebMessageModel } from "@globals/openapi-models/model/webMessageModel";
import { WebMessageType } from "@globals/openapi-models/model/webMessageType";

@Injectable()
export class BiWebMessageBaseService {
  protected http = inject(HttpClient);

  /**
   * Returns a list of WEB messages
   * @param includeDrafts Also return Web message drafts (they're a draft when creating during message
   * wizard flow where the wizard isn't finished). Default false.
   */
  public getWebMessages(customerId: number, profileId?: number, type?: WebMessageType, fromUtc?: string, toUtc?: string, includeDrafts = false, completedAsActive = false) {
    const params: { [key: string]: string | number | boolean } = {
      customerId,
      includeDrafts: includeDrafts,
      completedAsActive: completedAsActive
    };
    if (profileId) params.profileId = profileId;
    if (type) params.type = type;
    if (fromUtc) params.fromUtc = fromUtc;
    if (toUtc) params.toUtc = toUtc;

    return this.http.get<WebMessageModel[]>(ApiRouting.webMessageEndPoints.get.getWebMessages, { params: params });
  }
}
